export default "__VITE_ASSET__oRuU3nkL__"